import { render, staticRenderFns } from "./shang-pin-ling-jian.vue?vue&type=template&id=2388accc&scoped=true"
import script from "./shang-pin-ling-jian.vue?vue&type=script&lang=js"
export * from "./shang-pin-ling-jian.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-ling-jian.vue?vue&type=style&index=0&id=2388accc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388accc",
  null
  
)

export default component.exports